import Vue from "vue";
import Vuex from "vuex";
import campaign from "./campaign";
import forms from "./forms";
import advocate from "../advocate";
import api from "../api";
import tracking from "../tracking";
import cac from "./civicactioncenter";
import officials from "./officials";

Vue.use(Vuex);

const mod = {
  namespaced: true,
  modules: {
    campaign,
    forms,
    advocate,
    tracking,
    api,
    cac,
    officials
  }
};

export default new Vuex.Store(mod);
